<template>
  <el-select
    v-model="inValue"
    @focus="focus"
    :loading="loading"
    placeholder="请选择用水区域"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { GetWaterArea } from "@/api/public.js";
export default {
  data() {
    return {
      inValue: "",
      list: [],
      loading: false,
    };
  },
  methods: {
    //聚焦
    focus() {
      if (this.list.length == 0) {
        this.getList();
      } else {
        return false;
      }
    },
    //获取options列表
    getList() {
      this.loading = true;
      GetWaterArea({})
        .then((res) => {
          //   console.log(res);
          this.list = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    inValue: {
      handler(newVal) {
        this.$emit("select", newVal);
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal) {
        if (newVal == "") {
          this.inValue = newVal;
        } else {
          if (this.list.length == 0) {
            GetWaterArea({})
              .then((res) => {
                this.list = res.data.data.data;
                this.inValue = newVal;
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.inValue = newVal;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  model: {
    event: "select",
    prop: "value",
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>

<style lang="less" scoped>
</style>